import React, {useEffect, useState} from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/fr_FR";
import "dayjs/locale/fr";

const InputDate = props => {
	dayjs.locale('fr');
    const { attribute, returnType, type, value, placeholder, focus, readonly, isDisabled, eventsHandler } = props;
  	const [ date, setDate] = useState(dayjs(value, "DD/MM/YYYY"));
  	const dateFormat = "DD/MM/YYYY";

	const onChange = (date, dateString) => {
		if (eventsHandler.handleChange === undefined || eventsHandler.handleChange === null) return;
		eventsHandler.handleChange(attribute, returnType, dateString);
	}

	useEffect(() => {
		setDate(value.length > 0 ? dayjs(value, "DD/MM/YYYY") : null);
	}, [value]);

    return (
        <DatePicker value={date} onChange={onChange} format={dateFormat} locale={locale} />
    );
}

export default InputDate;
